// Fix: MindAR 1.2.x and A-Frame's text component both call getContext('2d') on
// the WebGL scene canvas. Once a canvas has a '2d' context, browsers permanently
// block webgl/webgl2 on it — leaving THREE.WebGLRenderer with a black feed.
// Solution: track which canvases own WebGL contexts via a WeakSet, then redirect
// any '2d' request on those canvases to a throwaway offscreen canvas.
const _webglCanvases = new WeakSet<HTMLCanvasElement>()
const _origGetContext = HTMLCanvasElement.prototype.getContext
;(HTMLCanvasElement.prototype as any).getContext = function (
  contextId: string,
  options?: any
) {
  // MUST check before calling origGetContext — once getContext('2d') is called
  // on a WebGL canvas the browser permanently blocks further WebGL context creation.
  if (contextId === '2d' && _webglCanvases.has(this as HTMLCanvasElement)) {
    const offscreen = document.createElement('canvas')
    offscreen.width = (this as HTMLCanvasElement).width || 512
    offscreen.height = (this as HTMLCanvasElement).height || 512
    return _origGetContext.call(offscreen, '2d', options)
  }
  const result = _origGetContext.call(this, contextId, options)
  // Record this canvas as WebGL-owned after it successfully receives a GL context
  if ((contextId === 'webgl' || contextId === 'webgl2') && result) {
    _webglCanvases.add(this as HTMLCanvasElement)
  }
  return result
}

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './style.css'
import App from './App'

createRoot(document.getElementById('react-root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
